import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useEffect, useState } from 'react';
import Aside from './components/Aside';
import Main from "./components/Main";
import ThemeContext from "./services/context/themeContext";
import Navbar from "../navbar/Navbar";
import { useRouter } from "next/router";

function Layout(_ref) {
  var RTL = _ref.RTL,
      children = _ref.children;

  var _useState = useState(RTL),
      rtl = _useState[0],
      setRtl = _useState[1];

  var _useState2 = useState(true),
      collapsed = _useState2[0],
      setCollapsed = _useState2[1];

  var _useState3 = useState(true),
      image = _useState3[0],
      setImage = _useState3[1];

  var _useState4 = useState(false),
      toggled = _useState4[0],
      setToggled = _useState4[1];

  var router = useRouter(); //redirect to https if http was requested

  useEffect(function () {
    if (window) {
      var protocol = window.location.protocol;
      var url = window.location.href;

      if (window.location.hostname !== 'localhost' && !protocol.includes('https')) {
        var newUrl = url.replace("http", "https");
        router.push(newUrl);
      }
    }
  }, []);

  var handleCollapsedChange = function handleCollapsedChange(checked) {
    setCollapsed(checked);
  };

  var handleRtlChange = function handleRtlChange(checked) {
    setRtl(checked);
  };

  var handleImageChange = function handleImageChange(checked) {
    setImage(checked);
  };

  var handleToggleSidebar = function handleToggleSidebar(value) {
    setToggled(value);
    handleCollapsedChange(toggled);
  };

  var theme = useContext(ThemeContext);
  return /*#__PURE__*/_jsxs("div", {
    className: "app ".concat(rtl ? 'rtl' : '', " ").concat(toggled ? 'toggled' : ''),
    children: [/*#__PURE__*/_jsx(Navbar, {
      collapsed: collapsed,
      toggled: toggled,
      handleToggleSidebar: handleToggleSidebar,
      handleCollapsedChange: handleCollapsedChange
    }), /*#__PURE__*/_jsxs("div", {
      className: "d-flex flex-row-reverse",
      children: [/*#__PURE__*/_jsx(Aside, {
        classes: theme,
        image: image,
        collapsed: collapsed,
        rtl: true,
        toggled: toggled,
        handleToggleSidebar: handleToggleSidebar,
        handleCollapsedChange: handleCollapsedChange
      }), /*#__PURE__*/_jsx(Main, {
        image: image,
        toggled: toggled,
        collapsed: collapsed,
        rtl: rtl,
        handleToggleSidebar: handleToggleSidebar,
        handleCollapsedChange: handleCollapsedChange,
        handleRtlChange: handleRtlChange,
        handleImageChange: handleImageChange,
        children: children
      })]
    })]
  });
}

export default Layout;